import { addCalendarDays, compareDate, dateParts, daysBetweenInclusive, weekdayForDate, zonedTimeToEpoch } from './math.js';
function normalizedTimes(schedule) {
    if (schedule.type === 'asNeeded')
        return [];
    return [...new Set(schedule.times)].sort();
}
export function expandSlots(treatment, timeZone, from, to) {
    if (treatment.planVersions?.length) {
        const versions = treatment.planVersions.filter((item) => !item.cancelledAt).sort((a, b) => a.effectiveAt - b.effectiveAt || a.recordedAt - b.recordedAt);
        return versions.flatMap((version, index) => version.state !== 'active' ? [] : expandSlots({ ...version, id: treatment.id }, timeZone, from, to)
            .filter((slot) => slot.epoch >= version.effectiveAt && slot.epoch < (versions[index + 1]?.effectiveAt ?? Infinity))).sort((a, b) => a.epoch - b.epoch);
    }
    if (treatment.active === false)
        return [];
    if (treatment.schedule.type === 'asNeeded')
        return [];
    const start = treatment.startDate && compareDate(treatment.startDate, from) > 0 ? treatment.startDate : from;
    const end = treatment.endDate && compareDate(treatment.endDate, to) < 0 ? treatment.endDate : to;
    if (compareDate(start, end) > 0)
        return [];
    const times = normalizedTimes(treatment.schedule);
    const out = [];
    const interval = treatment.schedule.type === 'interval' ? Math.max(1, treatment.schedule.everyDays) : 1;
    const startDay = treatment.startDate ?? start;
    let cursor = start;
    while (compareDate(cursor, end) <= 0) {
        const daysFromStart = daysBetweenInclusive(startDay, cursor) - 1;
        const matches = treatment.schedule.type === 'daily'
            || (treatment.schedule.type === 'weekly' && treatment.schedule.weekdays.includes(weekdayForDate(cursor)))
            || (treatment.schedule.type === 'interval' && daysFromStart % interval === 0);
        if (matches) {
            for (const localTime of times) {
                out.push({ treatmentId: treatment.id, localDate: cursor, localTime, epoch: zonedTimeToEpoch(cursor, localTime, timeZone) });
            }
        }
        cursor = addCalendarDays(cursor, 1);
    }
    return out.sort((a, b) => a.epoch - b.epoch || a.localTime.localeCompare(b.localTime) || a.treatmentId.localeCompare(b.treatmentId));
}
export function validateSchedule(schedule) {
    if (schedule.type === 'asNeeded')
        return [];
    const errors = [];
    if (schedule.times.length === 0)
        errors.push('times');
    for (const time of schedule.times)
        if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(time))
            errors.push(`time:${time}`);
    if (schedule.type === 'weekly' && schedule.weekdays.some((day) => day < 0 || day > 6))
        errors.push('weekdays');
    if (schedule.type === 'interval' && (!Number.isInteger(schedule.everyDays) || schedule.everyDays < 1))
        errors.push('everyDays');
    return errors;
}
export function clampDateWindow(from, to) {
    const a = dateParts(from);
    const b = dateParts(to);
    return Date.UTC(a.year, a.month, a.day) <= Date.UTC(b.year, b.month, b.day) ? { from, to } : { from: to, to: from };
}
